module.exports = __webpack_public_path__ + "img/okr_grey.b6dbacbe.svg";